import { Injectable, inject } from '@angular/core';
import { HTTP_AP_CloseProperty_Request } from '@api-new/propertyservice/HTTP_AP_CloseProperty_Request';
import { HTTP_AP_CompanyPropertySettings } from '@api-new/propertyservice/HTTP_AP_CompanyPropertySettings';
import { HTTP_AP_CreateHPIOutcodeToRegionEntry_Request } from '@api-new/propertyservice/HTTP_AP_CreateHPIOutcodeToRegionEntry_Request';
import { HTTP_AP_CreateProperty_Request } from '@api-new/propertyservice/HTTP_AP_CreateProperty_Request';
import { HTTP_AP_DeleteHPIOutcodeToRegionEntry_Request } from '@api-new/propertyservice/HTTP_AP_DeleteHPIOutcodeToRegionEntry_Request';
import { HTTP_AP_GetCompanyPropertySettings_Request } from '@api-new/propertyservice/HTTP_AP_GetCompanyPropertySettings_Request';
import { HTTP_AP_GetPropertyCard_Request } from '@api-new/propertyservice/HTTP_AP_GetPropertyCard_Request';
import { HTTP_AP_GetPropertyCard_Response } from '@api-new/propertyservice/HTTP_AP_GetPropertyCard_Response';
import { HTTP_AP_GetPropertyEquityGraph_Request } from '@api-new/propertyservice/HTTP_AP_GetPropertyEquityGraph_Request';
import { HTTP_AP_GetPropertyEquityGraph_Response } from '@api-new/propertyservice/HTTP_AP_GetPropertyEquityGraph_Response';
import { HTTP_AP_GetPropertyEquity_ForSummary_Request } from '@api-new/propertyservice/HTTP_AP_GetPropertyEquity_ForSummary_Request';
import { HTTP_AP_GetPropertyEquity_ForSummary_Response } from '@api-new/propertyservice/HTTP_AP_GetPropertyEquity_ForSummary_Response';
import { HTTP_AP_GetProperty_ForPropertyDetail_Request } from '@api-new/propertyservice/HTTP_AP_GetProperty_ForPropertyDetail_Request';
import { HTTP_AP_GetProperty_ForPropertyDetail_Response } from '@api-new/propertyservice/HTTP_AP_GetProperty_ForPropertyDetail_Response';
import { HTTP_AP_GetResidentialPropertyCard_Request } from '@api-new/propertyservice/HTTP_AP_GetResidentialPropertyCard_Request';
import { HTTP_AP_GetResidentialPropertyCard_Response } from '@api-new/propertyservice/HTTP_AP_GetResidentialPropertyCard_Response';
import { HTTP_AP_HPIOutcodeToRegionEntry } from '@api-new/propertyservice/HTTP_AP_HPIOutcodeToRegionEntry';
import { HTTP_AP_ListHPIIssues_Response } from '@api-new/propertyservice/HTTP_AP_ListHPIIssues_Response';
import { HTTP_AP_ListHPIOutcodeToRegionEntries_Request } from '@api-new/propertyservice/HTTP_AP_ListHPIOutcodeToRegionEntries_Request';
import { HTTP_AP_ListHPIOutcodeToRegionEntries_Response } from '@api-new/propertyservice/HTTP_AP_ListHPIOutcodeToRegionEntries_Response';
import { HTTP_AP_ListProperties_ForTable_Request } from '@api-new/propertyservice/HTTP_AP_ListProperties_ForTable_Request';
import { HTTP_AP_ListProperties_ForTable_Response } from '@api-new/propertyservice/HTTP_AP_ListProperties_ForTable_Response';
import { HTTP_AP_ListPropertyCards_Request } from '@api-new/propertyservice/HTTP_AP_ListPropertyCards_Request';
import { HTTP_AP_ListPropertyCards_Response } from '@api-new/propertyservice/HTTP_AP_ListPropertyCards_Response';
import { HTTP_AP_ListPropertyComparables_Request } from '@api-new/propertyservice/HTTP_AP_ListPropertyComparables_Request';
import { HTTP_AP_ListPropertyComparables_Response } from '@api-new/propertyservice/HTTP_AP_ListPropertyComparables_Response';
import { HTTP_AP_Property } from '@api-new/propertyservice/HTTP_AP_Property';
import { HTTP_AP_SetPropertyValue_Request } from '@api-new/propertyservice/HTTP_AP_SetPropertyValue_Request';
import { HTTP_AP_UnsetPropertyValue_Request } from '@api-new/propertyservice/HTTP_AP_UnsetPropertyValue_Request';
import { HTTP_AP_UpdateCompanyPropertySettings_Request } from '@api-new/propertyservice/HTTP_AP_UpdateCompanyPropertySettings_Request';
import { HTTP_AP_UpdateCompanyPropertySettings_Response } from '@api-new/propertyservice/HTTP_AP_UpdateCompanyPropertySettings_Response';
import { HTTP_AP_UpdateHPIOutcodeToRegionEntry_Request } from '@api-new/propertyservice/HTTP_AP_UpdateHPIOutcodeToRegionEntry_Request';
import { HTTP_AP_UpdatePropertyName_Request } from '@api-new/propertyservice/HTTP_AP_UpdatePropertyName_Request';
import { HTTP_AP_UpdatePropertyName_Response } from '@api-new/propertyservice/HTTP_AP_UpdatePropertyName_Response';
import { HTTP_AP_UpdateProperty_FromClientDetail_Request } from '@api-new/propertyservice/HTTP_AP_UpdateProperty_FromClientDetail_Request';
import { HTTP_CP_CloseProperty_Request } from '@api-new/propertyservice/HTTP_CP_CloseProperty_Request';
import { HTTP_CP_CreateProperty_Request } from '@api-new/propertyservice/HTTP_CP_CreateProperty_Request';
import { HTTP_CP_ListProperties_Response } from '@api-new/propertyservice/HTTP_CP_ListProperties_Response';
import { HTTP_CP_ListPropertyComparables_Request } from '@api-new/propertyservice/HTTP_CP_ListPropertyComparables_Request';
import { HTTP_CP_ListPropertyComparables_Response } from '@api-new/propertyservice/HTTP_CP_ListPropertyComparables_Response';
import { HTTP_CP_Property } from '@api-new/propertyservice/HTTP_CP_Property';
import { HTTP_CP_SetPropertyValue_Request } from '@api-new/propertyservice/HTTP_CP_SetPropertyValue_Request';
import { HTTP_CP_SetPropertyValue_Response } from '@api-new/propertyservice/HTTP_CP_SetPropertyValue_Response';
import { HTTP_CP_UnsetPropertyValue_Request } from '@api-new/propertyservice/HTTP_CP_UnsetPropertyValue_Request';
import { HTTP_CP_UnsetPropertyValue_Response } from '@api-new/propertyservice/HTTP_CP_UnsetPropertyValue_Response';
import { HTTP_CP_UpdateProperty_Request } from '@api-new/propertyservice/HTTP_CP_UpdateProperty_Request';
import { HTTP_X_FindAddress_Request } from '@api-new/propertyservice/HTTP_X_FindAddress_Request';
import { HTTP_X_FindAddress_Response } from '@api-new/propertyservice/HTTP_X_FindAddress_Response';
import { HTTP_X_RetrieveAddress_Request } from '@api-new/propertyservice/HTTP_X_RetrieveAddress_Request';
import { HTTP_X_RetrieveAddress_Response } from '@api-new/propertyservice/HTTP_X_RetrieveAddress_Response';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class PropertyApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_CloseProperty(request: HTTP_AP_CloseProperty_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/property-service/ap/CloseProperty`, request, options);
  }

  HTTP_AP_CreateHPIOutcodeToRegionEntry(
    request: HTTP_AP_CreateHPIOutcodeToRegionEntry_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_HPIOutcodeToRegionEntry> {
    return this.httpClient.post(`/property-service/ap/CreateHPIOutcodeToRegionEntry`, request, options);
  }

  HTTP_AP_CreateProperty(request: HTTP_AP_CreateProperty_Request, options?: IRequestOptions): Observable<HTTP_AP_Property> {
    // TODO AP Response object?

    return this.httpClient.post(`/property-service/ap/CreateProperty`, request, options);
  }

  HTTP_AP_DeleteHPIOutcodeToRegionEntry(
    request: HTTP_AP_DeleteHPIOutcodeToRegionEntry_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.delete(`/property-service/ap/DeleteHPIOutcodeToRegionEntry`, { params: request });
  }

  HTTP_AP_GetCompanyPropertySettings(
    request: HTTP_AP_GetCompanyPropertySettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyPropertySettings> {
    return this.httpClient.get(`/property-service/ap/GetCompanyPropertySettings`, { params: request });
  }

  HTTP_AP_GetProperty_ForPropertyDetail(
    request: HTTP_AP_GetProperty_ForPropertyDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetProperty_ForPropertyDetail_Response> {
    return this.httpClient.get(`/property-service/ap/GetProperty_ForPropertyDetail`, { params: request });
  }

  HTTP_AP_GetPropertyCard(
    request: HTTP_AP_GetPropertyCard_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPropertyCard_Response> {
    return this.httpClient.get(`/property-service/ap/GetPropertyCard`, { params: request });
  }

  HTTP_AP_GetPropertyEquity_ForSummary(
    request: HTTP_AP_GetPropertyEquity_ForSummary_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPropertyEquity_ForSummary_Response> {
    return this.httpClient.get(`/property-service/ap/GetPropertyEquity_ForSummary`, { params: request });
  }

  HTTP_AP_GetPropertyEquityGraph(
    request: HTTP_AP_GetPropertyEquityGraph_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPropertyEquityGraph_Response> {
    return this.httpClient.get(`/property-service/ap/GetPropertyEquityGraph`, { params: request });
  }

  HTTP_AP_GetResidentialPropertyCard(
    request: HTTP_AP_GetResidentialPropertyCard_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetResidentialPropertyCard_Response> {
    return this.httpClient.get(`/property-service/ap/GetResidentialPropertyCard`, { params: request });
  }

  HTTP_AP_ListHPIIssues(request?: undefined, options?: IRequestOptions): Observable<HTTP_AP_ListHPIIssues_Response> {
    return this.httpClient.get(`/property-service/ap/ListHPIIssues`, { params: request });
  }

  HTTP_AP_ListHPIOutcodeToRegionEntries(
    request: HTTP_AP_ListHPIOutcodeToRegionEntries_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListHPIOutcodeToRegionEntries_Response> {
    return this.httpClient.get(`/property-service/ap/ListHPIOutcodeToRegionEntries`, { params: request });
  }

  HTTP_AP_ListProperties_ForTable(
    request: HTTP_AP_ListProperties_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListProperties_ForTable_Response> {
    return this.httpClient.get(`/property-service/ap/ListProperties_ForTable`, { params: request });
  }

  HTTP_AP_ListPropertyCards(
    request: HTTP_AP_ListPropertyCards_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListPropertyCards_Response> {
    return this.httpClient.get(`/property-service/ap/ListPropertyCards`, { params: request });
  }

  HTTP_AP_ListPropertyComparables(
    request: HTTP_AP_ListPropertyComparables_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListPropertyComparables_Response> {
    return this.httpClient.get(`/property-service/ap/ListPropertyComparables`, { params: request });
  }

  HTTP_AP_SetPropertyValue(request: HTTP_AP_SetPropertyValue_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/property-service/ap/SetPropertyValue`, request, options);
  }

  HTTP_AP_UnsetPropertyValue(request: HTTP_AP_UnsetPropertyValue_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/property-service/ap/UnsetPropertyValue`, request, options);
  }

  HTTP_AP_UpdateCompanyPropertySettings(
    request: HTTP_AP_UpdateCompanyPropertySettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateCompanyPropertySettings_Response> {
    return this.httpClient.put(`/property-service/ap/UpdateCompanyPropertySettings`, request, options);
  }

  HTTP_AP_UpdateHPIOutcodeToRegionEntry(
    request: HTTP_AP_UpdateHPIOutcodeToRegionEntry_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_HPIOutcodeToRegionEntry> {
    return this.httpClient.put(`/property-service/ap/UpdateHPIOutcodeToRegionEntry`, request, options);
  }

  HTTP_AP_UpdateProperty_FromClientDetail(
    request: HTTP_AP_UpdateProperty_FromClientDetail_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.put(`/property-service/ap/UpdateProperty_FromClientDetail`, request, options);
  }

  HTTP_AP_UpdatePropertyName(
    request: HTTP_AP_UpdatePropertyName_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdatePropertyName_Response> {
    return this.httpClient.put(`/property-service/ap/UpdatePropertyName`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_CloseProperty(request: HTTP_CP_CloseProperty_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/property-service/cp/CloseProperty`, request, options);
  }

  HTTP_CP_CreateProperty(request: HTTP_CP_CreateProperty_Request, options?: IRequestOptions): Observable<HTTP_CP_Property> {
    return this.httpClient.post(`/property-service/cp/CreateProperty`, request, options);
  }

  HTTP_CP_ListProperties(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListProperties_Response> {
    return this.httpClient.get(`/property-service/cp/ListProperties`, { params: request });
  }

  HTTP_CP_ListPropertyComparables(
    request: HTTP_CP_ListPropertyComparables_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ListPropertyComparables_Response> {
    return this.httpClient.get(`/property-service/cp/ListPropertyComparables`, { params: request });
  }

  HTTP_CP_SetPropertyValue(
    request: HTTP_CP_SetPropertyValue_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_SetPropertyValue_Response> {
    return this.httpClient.post(`/property-service/cp/SetPropertyValue`, request, options);
  }

  HTTP_CP_UnsetPropertyValue(
    request: HTTP_CP_UnsetPropertyValue_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_UnsetPropertyValue_Response> {
    return this.httpClient.post(`/property-service/cp/UnsetPropertyValue`, request, options);
  }

  HTTP_CP_UpdateProperty(request: HTTP_CP_UpdateProperty_Request, options?: IRequestOptions): Observable<HTTP_CP_Property> {
    return this.httpClient.put(`/property-service/cp/UpdateProperty`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_X_FindAddress(request: HTTP_X_FindAddress_Request, options?: IRequestOptions): Observable<HTTP_X_FindAddress_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    // return this.httpClient.post(`/property-service/x/FindAddress`, request, options);
    return this.httpClient.post(`/property-service/x/address/Find`, request, options);
  }

  HTTP_X_RetrieveAddress(request: HTTP_X_RetrieveAddress_Request, options?: IRequestOptions): Observable<HTTP_X_RetrieveAddress_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    // return this.httpClient.post(`/property-service/x/RetrieveAddress`, request, options);
    return this.httpClient.post(`/property-service/x/address/Retrieve`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/property-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // TODO #6091 Delete this after the CompanyPropertySettings -> CompanySettingsForProperties migration is complete
}
